<template>
  <div class="page_redInvoice">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>红冲确认单</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs" v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-text="拼命加载中">
        <div class="tabsColor">
          <el-tabs v-model="activeName" type="card" @tab-click="changeTab" class="s_tabs_box">
            <el-tab-pane label="费用结算单" name="0" v-if="checkPermission(['settlement'], permissionLists)"></el-tab-pane>
            <el-tab-pane label="开票申请" name="1" v-if="checkPermission(['invoiceApp'], permissionLists)"></el-tab-pane>
            <el-tab-pane label="发票待办" name="2"
              v-if="checkPermission(['invoicePending'], permissionLists)"></el-tab-pane>
            <el-tab-pane label="部分开票" name="3"
              v-if="checkPermission(['invoicePartial'], permissionLists)"></el-tab-pane>
            <el-tab-pane label="已开票" name="4" v-if="checkPermission(['invoiced'], permissionLists)"></el-tab-pane>
            <el-tab-pane label="废票/红冲记录" name="5" v-if="checkPermission(['delList'], permissionLists)"></el-tab-pane>
            <el-tab-pane label="内部开票" name="7"
              v-if="checkPermission(['internalInvoicing'], permissionLists)"></el-tab-pane>
            <el-tab-pane label="全量查询" name="6"
              v-if="checkPermission(['FullDose_Query'], permissionLists)"></el-tab-pane>
            <el-tab-pane label="红冲确认单" name="8"
              v-if="checkPermission(['FullDose_Query'], permissionLists)"></el-tab-pane>
          </el-tabs>

          <el-form label-width="150px" :model="listQuery" ref="listQuery" :inline="true" :rules="rules">
            <el-form-item label="主体:" prop="subjectOfLegalAffairs">
              <el-select v-model="listQuery.subjectOfLegalAffairs" placeholder="" size="small" style="width: 515px;"
                clearable filterable @change="changeSub">
                <el-option v-for="(item, index) in legList" :key="index" :label="item.value"
                  :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="纳税人识别号:" prop="nsrsbh">
              <el-input v-model="listQuery.nsrsbh" size="small" style="width: 180px;"></el-input>
            </el-form-item>
            <el-form-item label="行政区划代码:" prop="areaid">
              <el-input v-model="listQuery.areaid" size="small" style="width: 180px;"></el-input>
            </el-form-item> -->
            <el-form-item label="确认单状态:">
              <el-select v-model="listQuery.qrdzt" placeholder="" value-key="Projectid" size="small"
                style="width: 180px;">
                <el-option label="无需确认" value="01"></el-option>
                <el-option label="销方录入待购方确认" value="02"></el-option>
                <el-option label="购方录入待销方确认" value="03"></el-option>
                <el-option label="销购双方已确认" value="04"></el-option>
                <el-option label="作废（销方录入购方否认）" value="05"></el-option>
                <el-option label="作废（购方录入销方否认）" value="06"></el-option>
                <el-option label="作废（超72小时未确认）" value="07"></el-option>
                <el-option label="作废（发起方已撤销）" value="08"></el-option>
                <el-option label="作废（确认后撤销）" value="09"></el-option>
                <el-option label="作废（异常凭证）" value="10"></el-option>
                <el-option label="作废（纳税人状态异常阻断）" value="11"></el-option>
                <el-option label="作废（自然人拒收）" value="12"></el-option>
                <el-option label="作废（已开具退税申请单）" value="13"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="录入日期起:" prop="lrrqq">
              <el-date-picker v-model="listQuery.lrrqq" type="date" value-format="yyyy-MM-dd" size="small"
                style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="录入日期止:" prop="lrrqz">
              <el-date-picker v-model="listQuery.lrrqz" type="date" value-format="yyyy-MM-dd" size="small"
                style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="录入方身份:">
              <el-select v-model="listQuery.lrfsf" placeholder="" value-key="Projectid" size="small"
                style="width: 180px;">
                <el-option label="销方" value="0"></el-option>
                <el-option label="购方" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="对方纳税人名称:">
              <el-input v-model="listQuery.dfnsrmc" size="small" style="width: 180px;"></el-input>
            </el-form-item>
            <el-form-item label="红字发票确认单编号:">
              <el-input v-model="listQuery.hzfpqrdbh" size="small" style="width: 180px;"></el-input>
            </el-form-item>
            <el-button type="success" size="small" @click="searchHandle" style="margin-left:15px;margin-top: 4px">查
              询</el-button>
          </el-form>
        </div>
        <el-table class="doc_table" border :max-height="tableHeight > 340 ? tableHeight - 200 : 500" :data="tableData"
          style="width:99%;margin-top: 20px;">
          <el-table-column label="红字发票确认单编号" prop="hzfpqrdbh" :show-overflow-tooltip="true" align="center"
            min-width="200" fixed="left">
          </el-table-column>
          <el-table-column label="购买方名称" prop="gmfmc" :show-overflow-tooltip="true" align="center" min-width="180">
          </el-table-column>
          <el-table-column label="购买方纳税人识别号" prop="gmfnsrsbh" :show-overflow-tooltip="true" align="center"
            min-width="160">
          </el-table-column>
          <el-table-column label="销售方名称" prop="xsfmc" :show-overflow-tooltip="true" align="center" min-width="160">
          </el-table-column>
          <el-table-column label="销售方纳税人识别号" prop="xsfnsrsbh" :show-overflow-tooltip="true" align="center"
            min-width="160">
          </el-table-column>
          <el-table-column label="蓝字发票号码" prop="lzfphm" :show-overflow-tooltip="true" align="center" min-width="160">
          </el-table-column>
          <el-table-column label="蓝字发票票种" prop="lzfppzdm" :show-overflow-tooltip="true" align="center" min-width="100">
          </el-table-column>
          <el-table-column label="蓝字合计金额" prop="lzhjje" :show-overflow-tooltip="true" align="center" min-width="100">
          </el-table-column>
          <el-table-column label="蓝字合计税额" prop="lzhjse" :show-overflow-tooltip="true" align="center" min-width="100">
          </el-table-column>
          <el-table-column label="蓝字开票日期" prop="lzkprq" :show-overflow-tooltip="true" align="center" min-width="160">
          </el-table-column>
          <el-table-column label="增值税用途状态" prop="zzsytzt" :show-overflow-tooltip="true" align="center" min-width="160">
          </el-table-column>
          <el-table-column label="红字冲销金额" prop="hzcxje" :show-overflow-tooltip="true" align="center" min-width="160">
          </el-table-column>
          <el-table-column label="红字冲销税额" prop="hzcxse" :show-overflow-tooltip="true" align="center" min-width="160">
          </el-table-column>
          <el-table-column label="红字原因" prop="hzcxyy" :show-overflow-tooltip="true" align="center" min-width="160">
          </el-table-column>
          <el-table-column label="红字确认状态" prop="hzqrzt" :show-overflow-tooltip="true" align="center" min-width="160">
          </el-table-column>
          <el-table-column label="确认日期" prop="qrrq" :show-overflow-tooltip="true" align="center" min-width="160">
          </el-table-column>
          <el-table-column label="已开具红字发票" prop="ykjhzfpbz" :show-overflow-tooltip="true" align="center"
            min-width="160">
          </el-table-column>
          <el-table-column label="红字发票号码" prop="hzfphm" :show-overflow-tooltip="true" align="center" min-width="160">
          </el-table-column>
          <el-table-column label="红字开票日期" prop="hzkprq" :show-overflow-tooltip="true" align="center" min-width="160">
          </el-table-column>
          <el-table-column label="是否有效" prop="yxbz" :show-overflow-tooltip="true" align="center" min-width="160">
          </el-table-column>
          <el-table-column label="入账状态" prop="rzzt" :show-overflow-tooltip="true" align="center" min-width="160">
          </el-table-column>
          <el-table-column label="录入日期" prop="hzqrdlrrq" :show-overflow-tooltip="true" align="center" min-width="160">
          </el-table-column>
          <el-table-column label="确认即开票" prop="qrjkpbz" :show-overflow-tooltip="true" align="center" min-width="100">
          </el-table-column>
          <el-table-column label="操作" align="center" min-width="200" fixed="right">
            <template slot-scope="{row}">
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="viewDtl(row)">查看</el-button>
                <el-popconfirm title="请确认是否撤销红冲" @confirm="revokeHandle(row)" v-if="row.ykjhzfpbz != '是'"
                  style="margin: 0 10px;">
                  <el-button type="text" slot="reference" size="small">撤销红冲</el-button>
                </el-popconfirm>
                <el-button type="text" v-if="row.ykjhzfpbz != '是'" size="small" @click="redInv(row)">红冲开票</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="listQuery.pageNumber"
            :page-size="listQuery.pageSize" @size-change="handleSizeChange" :page-sizes="[5, 10, 20, 50]"
            layout="total,sizes,prev,pager,next,jumper" :total="totalCount"></el-pagination>
        </div>
        <div class="ftabBtn flex">

        </div>
      </div>
    </div>

    <el-dialog :title="type == 'redInv' ? '红冲开票' : '详情'" :visible.sync="showRedInv" width="840px"
      class="res_dialog enter_dialog">
      <el-form v-if="redInvDetail" label-width="120px" class="red-inv-detail-form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="销售方名称:">
              <span>{{ redInvDetail.xsfmc }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="销售方税号:">
              <span>{{ redInvDetail.xsfnsrsbh }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="购买方名称:">
              <span>{{ redInvDetail.gmfmc }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="购买方税号:">
              <span>{{ redInvDetail.gmfnsrsbh }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="蓝字发票号码:">
              <span>{{ redInvDetail.lzfphm }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开票日期:">
              <span>{{ redInvDetail.lzkprq }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="蓝字合计金额:">
              <span>{{ redInvDetail.lzhjje }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="蓝字合计税额:">
              <span>{{ redInvDetail.lzhjse }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="红字冲销金额:">
              <span>{{ redInvDetail.hzcxje }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="红字冲销税额:">
              <span>{{ redInvDetail.hzcxse }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否纸质发票:">
              <span>{{ redInvDetail.sfzzfp === 'Y' ? '是' : '否' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结果状态:">
              <span>{{ redInvDetail.jgzt === 1 ? '处理成功' : '处理失败' }}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="错误信息:" v-if="redInvDetail.cwxx">
          <span class="error-info">{{ redInvDetail.cwxx }}</span>
        </el-form-item>

        <el-divider>红字确认信息明细</el-divider>

        <el-table v-if="showRedInv" :data="redInvDetail.hzqrxxmxlb" border max-height="300" class="doc_table">
          <el-table-column prop="xh" label="序号" width="60" align="center"></el-table-column>
          <el-table-column prop="sphfwssflhbbm" label="商品编码" show-overflow-tooltip min-width="100"
            align="center"></el-table-column>
          <el-table-column prop="hwhyslwfwmc" label="货物或劳务名称" show-overflow-tooltip min-width="200"
            align="center"></el-table-column>
          <el-table-column prop="ggxh" label="规格型号" show-overflow-tooltip min-width="100"
            align="center"></el-table-column>
          <el-table-column prop="spfwjc" label="简称" show-overflow-tooltip min-width="100"
            align="center"></el-table-column>
          <el-table-column prop="xmmc" label="项目名称" show-overflow-tooltip min-width="160"
            align="center"></el-table-column>
          <el-table-column prop="dw" label="单位" width="80" align="center"></el-table-column>
          <el-table-column prop="fpspsl" label="数量" width="100" align="center"></el-table-column>
          <el-table-column prop="fpspdj" label="单价" width="100" align="center"></el-table-column>
          <el-table-column prop="je" label="金额" width="100" align="center">
            <template slot-scope="scope">{{ formatAmount(scope.row.je) }}</template>
          </el-table-column>
          <el-table-column prop="s lv" label="税率(%)" width="80" align="center">
            <template slot-scope="scope">{{ (scope.row.slv * 100).toFixed(2) }}</template>
          </el-table-column>
          <el-table-column prop="se" label="税额" width="100" align="center">
            <template slot-scope="scope">{{ formatAmount(scope.row.se) }}</template>
          </el-table-column>
        </el-table>
      </el-form>

      <span slot="footer" class="dialog-footer" v-if="type == 'redInv'">
        <el-button @click="showRedInv = false" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmRedHandle" size="small" :loading="isBtnLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import xz from "../../common";
import checkPermission from '@/utils/permission' // 权限判断函数
export default {
  data() {
    return {
      tableHeight: 0,
      listQuery: {
        subjectOfLegalAffairs: '',
        nsrsbh: '', //纳税人识别号
        areaid: '', //行政区划代码
        pageNumber: 1,
        pageSize: 10, //分页大小仅支持5,10,20,50
        gxfxz: '0', //0：销方1：购方（默认0）
        qrdzt: '', //
        qrjkpbz: '', //确认即开票Y:是N:否
        dfnsrmc: '', //对方纳税人名称
        lrrqq: '', //录入日期起
        lrrqz: '', //录入日期止
        kpzt: '', //开票状态Y:已开具N:未开具
        lrfsf: '', //录入方身份0：销方1：购方
        hzfpqrdbh: '' //红字发票确认单编号
      },
      activeName: "8",
      loading: false,
      permissionLists: [],
      // 按钮权限参数
      butQuery: {
        path: '/invoicing',
        powerEnName: 'invoicing'
      },
      tableData: [],
      totalCount: 0,
      redInvDetail: {},
      rowData: {},
      hzfpkjyy: '',
      showRedInv: false,
      isBtnLoading: false,
      legList: [],
      type: '',
      rules: {
        subjectOfLegalAffairs: {
          required: true,
          message: '请选择主体',
          trigger: 'change'
        },
        lrrqq: {
          required: true,
          message: '请选择录入日期起',
          trigger: 'change'
        },
        lrrqz: {
          required: true,
          message: '请选择录入日期止',
          trigger: 'change'
        },
      }
    }
  },
  created() {
    this.tableHeight = Number(document.body.clientHeight)
    this.getButtonPower();
    this.getlegalsubjectlist();
  },
  mounted() {

  },
  methods: {
    checkPermission,
    // 获取按钮权限
    getButtonPower() {
      let that = this
      xz.getbtnPowerIdBypage(this.butQuery).then(res => {
        // console.log('按钮',res)
        if (res.status == 'ok') {
          let resmsg = res.msg
          if (!this.isNull(resmsg)) {
            for (let index = 0; index < resmsg.length; index++) {
              let element = resmsg[index];
              this.permissionLists.push(element.Enname);
            }
            if (that.checkPermission(['publicResources_page_list'], that.permissionLists)) { }
          } else {
            this.permissionLists = []
          }
        } else {
          this.permissionLists = []
        }
      })
    },
    //获取法务主体列表
    getlegalsubjectlist() {
      let data = {
        keyWord: '',
        pageSize: '10000',
        UserId: Cookies.get("userid-b")
      }
      xz.BasicFun(data, 'GetSubjectOfLegalAffairs').then(res => {
        if (res.status == 'ok') {
          this.legList = res.data;
        } else {
          this.legList = [];
        }
      })
    },
    changeSub(val) {
      xz.GetCorporationData(val).then((res) => {
        if (res.status == "ok") {
          if (!res.data.isonline) {
            this.showLogin = true;
            this.listQuery.nsrsbh = '';
            this.listQuery.areaid = '';
            this.listQuery.subjectOfLegalAffairs = '';
          } else {
            this.listQuery.nsrsbh = res.data.taxNum;
            this.listQuery.areaid = res.data.value;
          }
        } else {
          this.listQuery.nsrsbh = '';
          this.listQuery.areaid = '';
          this.listQuery.subjectOfLegalAffairs = '';
          this.$message.warning('获取该主体信息异常')
        }
      })
    },
    changeTab() {
      if (this.activeName != '8') {
        this.$router.push({
          path: '/invoicing',
          query: {
            activeName: this.activeName
          }
        })
      }
    },
    searchHandle() {
      this.listQuery.pageNumber = 1;
      this.getList();
    },
    getList() {
      this.$refs['listQuery'].validate((valid) => {
        if (valid) {
          this.loading = true;
          xz.IvoiceFun(this.listQuery, 'PostThirdParty_queryRedInvoiceVoucher').then(res => {
            if (res.status == 'ok') {
              this.loading = false;
              this.tableData = res.data.data;
              this.totalCount = res.data.totalCount;
            } else {
              this.loading = false;
              this.tableData = [];
              this.totalCount = 0;
            }
          })
        }
      })

    },
    //分页
    handleCurrentChange(val) {
      this.listQuery.pageNumber = Number(val)
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.pageNumber = 1
      this.listQuery.pageSize = Number(val)
      this.getList()
    },
    //判断是否为空(包含0)
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
    },
    //查看
    viewDtl(row) {
      let rowData = {
        nsrsbh: this.listQuery.nsrsbh,
        areaid: this.listQuery.areaid,
        lzfphm: row.lzfphm,
        hzfpqrdtjrq: moment(row.hzqrdlrrq).format('YYYY-MM-DD'),
        hzfpqrdbh: row.hzfpqrdbh
      }
      this.loading = true;
      xz.IvoiceFun(rowData, 'PostThirdParty_queryRedInvoiceVoucherDetail').then(res => {
        if (res.status == 'ok') {
          try {
            this.loading = false;
            this.type = 'view';
            this.redInvDetail = res.data.hzfpxx;
            this.redInvDetail.hzqrxxmxlb = res.data.hzfpxx.hzqrdmxlb;
            this.showRedInv = true;
          } catch (e) {
            this.loading = false;
            this.$message.error('获取详情信息异常')
          }
        } else {
          this.loading = false;
          this.$message.error(res.msg)
        }
      })
    },
    //撤销
    revokeHandle(row) {
      //有id 内部
      let rowData = {};
      let pagename = '';
      if (!this.isNull(row.actualBillingBasicId)) {
        rowData = {
          actualBillingBasicId: row.actualBillingBasicId
        }
        pagename = 'PostThirdParty_revokeRedInvoiceVoucher';
      } else {
        rowData = {
          nsrsbh: this.listQuery.nsrsbh,
          areaid: this.listQuery.areaid,
          lzfphm: row.lzfphm,
          hzfpqrdtjrq: moment(row.hzqrdlrrq).format('YYYY-MM-DD'),
          hzfpqrdbh: row.hzfpqrdbh
        }
        pagename = 'revokeRedInvoiceVoucher';
      }
      this.loading = true;
      xz.IvoiceFun(rowData, pagename).then(res => {
        if (res.status == 'ok') {
          this.$message.success('撤销成功！');
          this.loading = false;
          this.getList();
        } else {
          this.$message.error(res.msg);
          this.loading = false;
        }
      })
    },
    redInv2() {
      this.redInvDetail = {
        xsfmc: "宁波某某科技有限公司", // 销售方名称
        xsfnsrsbh: "91330201074930876R", // 销售方税号
        gmfmc: "上海某某贸易有限公司", // 购买方名称
        gmfnsrsbh: "91310115756284715X", // 购买方税号
        lzfphm: "2220000123456789", // 蓝字发票号码
        lzkprq: "2025-10-15", // 开票日期
        lzhjje: "10000.00", // 蓝字合计金额
        lzhjse: "1300.00", // 蓝字合计税额
        hzcxje: "-8000.00", // 红字冲销金额
        hzcxse: "-1040.00", // 红字冲销税额
        sfzzfp: "N", // 是否纸质发票(Y/N)
        jgzt: 1, // 结果状态(1:成功,其他:失败)
        cwxx: "",
        hzqrxxmxlb: [{
          xh: 1, // 序号
          hwhyslwfwmc: "服务器设备", // 货物或劳务名称
          ggxh: "DELL R740", // 规格型号
          dw: "台", // 单位
          fpspsl: 2, // 数量
          fpspdj: 5000.00, // 单价
          je: 10000.00, // 金额
          slv: 0.13, // 税率
          se: 1300.00 // 税额
        },
        {
          xh: 2,
          hwhyslwfwmc: "技术服务费",
          ggxh: "",
          dw: "年",
          fpspsl: 1,
          fpspdj: 20000.00,
          je: 20000.00,
          slv: 0.06,
          se: 1200.00
        }
        ]
      }
      this.showRedInv = true;
    },
    //
    redInv(row) {
      this.rowData = row;
      //有id 内部
      let rowData = {};
      let pagename = '';
      // if (!this.isNull(row.actualBillingBasicId)) {
      //   rowData = {
      //     id: row.actualBillingBasicId,
      //     type: 2
      //   }
      //   pagename = 'SetinitRedInvoice';
      // } else {
      //   rowData = {
      //     nsrsbh: this.listQuery.nsrsbh,
      //     areaid: this.listQuery.areaid,
      //     lzfphm: row.lzfphm,
      //     qymc: row.xsfmc,
      //     lzfpkprq: row.lzkprq
      //   }
      //   pagename = 'PostThirdParty_queryRedInvoiceVoucherDetail';
      // }
      rowData = {
        nsrsbh: this.listQuery.nsrsbh,
        areaid: this.listQuery.areaid,
        lzfphm: row.lzfphm,
        hzfpqrdtjrq: moment(row.hzqrdlrrq).format('YYYY-MM-DD'),
        hzfpqrdbh: row.hzfpqrdbh
      }
      pagename = 'PostThirdParty_queryRedInvoiceVoucherDetail';
      this.loading = true;
      xz.IvoiceFun(rowData, pagename).then(res => {
        if (res.status == 'ok') {
          this.type = 'redInv';
          this.redInvDetail = res.data.hzfpxx;
          this.redInvDetail.hzqrxxmxlb = res.data.hzfpxx.hzqrdmxlb;
          this.showRedInv = true;
          this.loading = false;
        } else {
          this.loading = false;
          this.$message.error(res.msg);
        }
      })
    },
    // 格式化金额显示
    formatAmount(amount) {
      if (amount === undefined || amount === null) return '-';
      return parseFloat(amount).toFixed(2);
    },
    confirmRedHandle() {
      this.isBtnLoading = true;
      let d = {};
      let pagename = '';
      // if (!this.isNull(this.rowData.actualBillingBasicId)) {
      //   d = {
      //     actualBillingBasicId: this.rowData.actualBillingBasicId,
      //   }
      //   pagename = 'PostThirdParty_redInvoiceBilling'
      // } else {
        d = {
          nsrsbh: this.listQuery.nsrsbh,
          areaid: this.listQuery.areaid,
          lzfphm: this.rowData.lzfphm,
          hzfpqrdtjrq: moment(this.rowData.hzqrdlrrq).format('YYYY-MM-DD'),
          hzfpqrdbh: this.rowData.hzfpqrdbh
        }
        pagename = 'redInvoiceBilling'
      // }
      xz.IvoiceFun(d, pagename).then(res => {
        if (res.status == 'ok') {
          this.isBtnLoading = false;
          this.showRedInv = false;
          this.getList();
          this.$message.success('提交成功！')
        } else {
          this.isBtnLoading = false;
          this.$message.error(res.msg);
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.ftabs {
  background: #fff;
  padding: 0px 16px 16px;
  margin-bottom: 16px;
}

.ftabBtn {
  padding: 10px 0;
}

.red-inv-detail-form {
  padding: 20px;

  .error-info {
    color: #f56c6c;
  }
}

.red-inv-detail-dialog {
  .el-dialog__body {
    padding: 10px 20px;
  }
}
</style>
<style>
.page_redInvoice .eleTabBtn .el-button--text {
  color: #19bd92;
  font-size: 13px;
  padding: 0;
}

.page_redInvoice .doc_table .el-table__body td.el-table__cell {
  padding: 5px 0;
}

.page_redInvoice .doc_table .el-table__body th.el-table__cell {
  padding: 8px 0;
}

.page_redInvoice .el-input__icon {
  height: 32px;
  line-height: 32px;
}

.page_redInvoice .el-input-group__append,
.el-input-group__prepend {
  padding: 0 10px;
  background: #fff;
}

.page_redInvoice .injuryTabBtn .el-button--text {
  color: #19bd92;
  font-size: 13px;
  padding: 0;
}

.page_redInvoice .ftabBtn .el-form-item {
  margin-bottom: 0;
}

.page_redInvoice .tabsColor .el-form-item {
  margin-bottom: 10px;
}

.page_redInvoice .red-inv-detail-form .el-form-item {
  margin-bottom: 5px;
}

.el-form-item__error {
  top: 33px;
}
</style>